import { render } from "./CampaignList.vue?vue&type=template&id=36d8d81f&scoped=true"
import script from "./CampaignList.vue?vue&type=script&lang=js"
export * from "./CampaignList.vue?vue&type=script&lang=js"

import "./CampaignList.vue?vue&type=style&index=0&id=36d8d81f&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1198/src/s3/00/frontend/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36d8d81f"]])

export default __exports__